import { createSlice } from '@reduxjs/toolkit';
import {
  addServiceToWorkOrder,
  cloaseAddServiceModal,
  closeDeleteConfirmationModal,
  cancelStepChangeStatus,
  closeEditVechileModal,
  deleteServiceFromWorkOrder,
  editVehicleDetails,
  getPrices,
  getWorkOrderData,
  openAddServiceModal,
  openEditVechileModal,
  getWorkOrderToPdf,
  setPromiseDate,
  addSurvey,
  resetSurveySentStatus,
  openModalQualitySurvey,
  closeModalQualitySurvey,
  hideCancelConfirmationSnackBar,
  addWorkOrderNote,
  clearCompletionEditStatus,
  approveOrder,
  declineOrder,
  openDeclineConfirm,
  closeDeclineConfirm,
  clearAddServiceError,
} from '../actions/orderDetailsActions';
import {
  clearDeclinedConfirmation,
  closeApproveDialog,
} from '../actions/orders/unapprovedActions';

const initialState = {
  workOrder: null,
  isLoading: false,
  isEditVehicleLoading: false,
  isAddServiceLoading: false,
  isDeleteServiceLoading: false,
  addServiceError: null,
  isLoadingAddSurvey: false,

  isProcessingAction: false,
  declineConfirmOpen: false,
  approveDialogOpened: false,
  declinedSuccesful: null,

  editVehicleModalOpen: false,
  addServiceModalOpen: false,
  addSurveyModalOpen: false,
  prices: [],
  deleteServiceStatus: null,
  isLoadingPdf: false,
  dataPdf: null,
  surveySentStatus: null,
  changeStepStatus: {
    isApiLoading: false,
    status: null,
    token: null,
  },
  addNewNote: {
    isNoteLoading: false,
  },
  promiseDate: {
    isLoadingEditCompletion: false,
    status: null,
  },
};

const orderDetailsReducer = createSlice({
  name: 'orderDetails',
  initialState,
  extraReducers: {
    [openAddServiceModal.type]: state => {
      state.addServiceModalOpen = true;
    },
    [hideCancelConfirmationSnackBar.type]: state => {
      state.changeStepStatus.status = null;
      state.changeStepStatus.token = null;
    },
    [cloaseAddServiceModal.type]: state => {
      state.addServiceModalOpen = false;
    },
    [closeDeleteConfirmationModal.type]: state => {
      state.deleteServiceStatus = null;
    },
    [getWorkOrderData.pending]: () => ({
      ...initialState,
      isLoading: true,
    }),
    [getWorkOrderData.rejected]: state => {
      state.isLoading = false;
      state.workOrder = null;
    },
    [getWorkOrderData.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.workOrder = payload.data;
    },
    [editVehicleDetails.pending]: state => {
      state.isEditVehicleLoading = true;
    },
    [editVehicleDetails.fulfilled]: (state, { payload }) => {
      state.isEditVehicleLoading = false;
      state.editVehicleModalOpen = false;
      state.workOrder = payload;
    },
    [openEditVechileModal.type]: state => {
      state.editVehicleModalOpen = true;
    },
    [closeEditVechileModal.type]: state => {
      state.editVehicleModalOpen = false;
    },
    [getPrices.fulfilled]: (state, { payload }) => {
      state.prices = payload.prices.filter(
        price =>
          !state.workOrder.services.some(
            woService => woService.servicePriceId === price.servicePriceId
          )
      );
    },
    [deleteServiceFromWorkOrder.pending]: (state, { payload }) => {
      state.isDeleteServiceLoading = true;
      state.deleteServiceStatus = null;
    },
    [deleteServiceFromWorkOrder.rejected]: (state, { payload }) => {
      state.isDeleteServiceLoading = false;
      state.deleteServiceStatus = {
        status: payload.status,
        token: payload.token,
      };
    },
    [deleteServiceFromWorkOrder.fulfilled]: (state, { payload }) => {
      state.isDeleteServiceLoading = false;
      state.deleteServiceStatus = {
        status: payload.status,
        token: null,
      };
      state.workOrder = payload.data;
    },
    [addServiceToWorkOrder.fulfilled]: (state, { payload }) => {
      state.workOrder = payload;
      state.isAddServiceLoading = false;
      state.addServiceModalOpen = false;
    },
    [addServiceToWorkOrder.pending]: (state, { payload }) => {
      state.isAddServiceLoading = true;
    },
    [addServiceToWorkOrder.rejected]: (state, { payload }) => {
      state.isAddServiceLoading = false;
      state.addServiceModalOpen = false;
      state.addServiceError = payload;
    },
    [clearAddServiceError.type]: state => {
      state.addServiceError = null;
    },
    [getWorkOrderToPdf.pending]: state => {
      state.isLoadingPdf = true;
    },
    [getWorkOrderToPdf.fulfilled]: (state, { payload }) => {
      state.isLoadingPdf = false;
      state.dataPdf = payload;
    },
    [cancelStepChangeStatus.pending]: state => {
      state.changeStepStatus.isApiLoading = true;
    },
    [cancelStepChangeStatus.rejected]: (state, { payload }) => {
      state.changeStepStatus.isApiLoading = false;
      state.changeStepStatus.status = payload.status;
      state.changeStepStatus.token = payload.token;
    },
    [cancelStepChangeStatus.fulfilled]: (state, { payload }) => {
      state.changeStepStatus.isApiLoading = false;
      state.changeStepStatus.status = payload.status;
      state.changeStepStatus.token = null;
      state.workOrder = payload.data;
    },
    [setPromiseDate.pending]: state => {
      state.promiseDate.isLoadingEditCompletion = true;
    },
    [setPromiseDate.rejected]: state => {
      state.promiseDate.isLoadingEditCompletion = false;
      state.promiseDate.status = 'error';
    },
    [setPromiseDate.fulfilled]: (state, { payload }) => {
      state.promiseDate.isLoadingEditCompletion = false;
      state.promiseDate.status = 'success';
      state.workOrder = payload;
    },
    [clearCompletionEditStatus.type]: state => {
      state.promiseDate.status = null;
      state.promiseDate.token = null;
    },
    [addSurvey.pending]: state => {
      state.isLoadingAddSurvey = true;
    },
    [addSurvey.rejected]: state => {
      state.isLoadingAddSurvey = false;
      state.surveySentStatus = 'error';
      state.addSurveyModalOpen = false;
    },
    [addSurvey.fulfilled]: (state, { payload }) => {
      state.isLoadingAddSurvey = false;
      state.workOrder = payload;
      state.surveySentStatus = 'success';
      state.addSurveyModalOpen = false;
    },
    [resetSurveySentStatus.type]: state => {
      state.surveySentStatus = null;
    },
    [openModalQualitySurvey.type]: state => {
      state.addSurveyModalOpen = true;
    },
    [closeModalQualitySurvey.type]: state => {
      state.addSurveyModalOpen = false;
    },
    [addWorkOrderNote.pending]: state => {
      state.addNewNote.isNoteLoading = true;
    },
    [addWorkOrderNote.rejected]: state => {
      state.addNewNote.isNoteLoading = false;
    },
    [addWorkOrderNote.fulfilled]: (state, { payload }) => {
      state.addNewNote.isNoteLoading = false;
      state.workOrder = payload.data;
    },
    [approveOrder.pending]: state => {
      state.approveDialogOpened = false;
      state.isProcessingAction = true;
    },
    [approveOrder.fulfilled]: (state, { payload }) => {
      state.isProcessingAction = false;
      state.approveDialogOpened = true;
      state.workOrder = payload;
    },
    [approveOrder.rejected]: state => {
      state.approveDialogOpened = false;
      state.isProcessingAction = false;
    },
    [declineOrder.pending]: state => {
      state.isProcessingAction = true;
    },
    [declineOrder.rejected]: state => {
      state.isProcessingAction = false;
      state.declineConfirmOpen = false;
      state.declinedSuccesful = false;
    },
    [declineOrder.fulfilled]: (state, { payload }) => {
      state.isProcessingAction = false;
      state.declineConfirmOpen = false;
      state.declinedSuccesful = true;
      state.workOrder = payload;
    },
    [openDeclineConfirm.type]: (state, { payload }) => {
      state.declineConfirmOpen = true;
    },
    [closeDeclineConfirm.type]: (state, { payload }) => {
      state.declineConfirmOpen = false;
    },
    [closeApproveDialog.type]: state => {
      state.approveDialogOpened = false;
    },
    [clearDeclinedConfirmation.type]: state => {
      state.declinedSuccesful = null;
    },
  },
});

export default orderDetailsReducer;
